export const professionalRoleTypes = {
  attorney: "Attorney",
  divorce_coach: "Divorce Coach",
  coparent_coach: "Co-Parenting Coach",
};
export type ProfessionalRoleType =
  (typeof professionalRoleTypes)[keyof typeof professionalRoleTypes];
